import { apiFetch } from './api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
}

export function isPushSupported() {
  return (
    typeof window !== 'undefined' &&
    'Notification' in window &&
    'serviceWorker' in navigator &&
    'PushManager' in window
  );
}

export function getNotificationPermission() {
  if (!('Notification' in window)) return 'unsupported';
  return Notification.permission;
}

async function getServiceWorkerRegistration() {
  if (!('serviceWorker' in navigator)) return null;

  let registration = await navigator.serviceWorker.getRegistration('/');
  if (!registration) {
    registration = await navigator.serviceWorker.register('/sw.js');
  }

  await navigator.serviceWorker.ready;
  return registration;
}

export async function enablePushNotifications() {
  if (!isPushSupported()) {
    throw new Error('هذا الجهاز أو المتصفح لا يدعم إشعارات PWA حالياً');
  }

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    throw new Error('لم يتم السماح بالإشعارات من إعدادات الهاتف');
  }

  const keyResponse = await apiFetch('/push/vapid-public-key');
  const keyData = await keyResponse.json();
  if (!keyResponse.ok || !keyData.publicKey) {
    throw new Error(keyData.message || 'تعذر جلب مفتاح إشعارات الهاتف');
  }

  const registration = await getServiceWorkerRegistration();
  if (!registration) {
    throw new Error('تعذر تسجيل Service Worker الخاص بالتطبيق');
  }

  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(keyData.publicKey)
    });
  }

  const saveResponse = await apiFetch('/push/subscribe', {
    method: 'POST',
    body: JSON.stringify(subscription)
  });
  const saveData = await saveResponse.json().catch(() => ({}));

  if (!saveResponse.ok) {
    throw new Error(saveData.message || 'فشل حفظ جهاز الإشعارات');
  }

  try {
    localStorage.setItem('anees_push_enabled', '1');
  } catch (_) {}

  return saveData;
}

export async function sendTestPushNotification() {
  const response = await apiFetch('/push/test', { method: 'POST' });
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.message || 'فشل إرسال إشعار الاختبار');
  }

  return data;
}

export async function getPushStatus() {
  const permission = getNotificationPermission();

  if (!isPushSupported()) {
    return { supported: false, permission, subscribed: false };
  }

  try {
    const registration = await navigator.serviceWorker.getRegistration('/');
    const subscription = registration ? await registration.pushManager.getSubscription() : null;
    return {
      supported: true,
      permission,
      subscribed: Boolean(subscription)
    };
  } catch (_) {
    return { supported: true, permission, subscribed: false };
  }
}
